import {type UserAutocomplete} from '@mattermost/types/autocomplete';
import {type Group} from '@mattermost/types/groups';
import {type UserProfile} from '@mattermost/types/users';
import {Client4} from 'mattermost-redux/client';

import type {GroupMention, Mention, UserMention} from './types';

function getDisplayName(userProfile: UserProfile) {
    if (userProfile.first_name && userProfile.last_name) {
        return `${userProfile.first_name} ${userProfile.last_name}`;
    }

    if (userProfile.first_name) {
        return userProfile.first_name;
    }

    if (userProfile.last_name) {
        return userProfile.last_name;
    }

    return userProfile.username;
}

function mapUserProfileToUserMention(userProfile: UserProfile): UserMention {
    return {
        data: userProfile,
        displayName: getDisplayName(userProfile),
        handle: userProfile.username || userProfile.username,
        label: userProfile.username,
        id: userProfile.username,
        type: 'user',
        imageUrl: Client4.getProfilePictureUrl(userProfile.id, userProfile.last_picture_update),
    };
}

type TransformedUsers = {
    users: Mention[];
    bots: Mention[];
}

export function transformUsersAutocompleteResponse(response: UserAutocomplete): TransformedUsers {
    const {users, out_of_channel: outOfChannel = []} = response;

    // eslint-disable-next-line no-warning-comments
    // TODO: будет дополнительно перерабатываться в рамках
    // https://jira.tcsbank.ru/browse/TIME-12338
    const nonBotUsers = users.filter((user) => !user.is_bot).map(mapUserProfileToUserMention);
    const botUsers = users.filter((user) => user.is_bot).map(mapUserProfileToUserMention);

    const nonBotOutOfChannel = outOfChannel.filter((user) => !user.is_bot).map(mapUserProfileToUserMention);
    const botOutOfChannel = outOfChannel.filter((user) => user.is_bot).map(mapUserProfileToUserMention);

    return {
        users: nonBotUsers.concat(nonBotOutOfChannel),
        bots: botUsers.concat(botOutOfChannel),
    };
}

function mapGroupToGroupMention(group: Group): GroupMention {
    return {
        data: group,
        displayName: group.display_name,
        handle: group.name,
        label: group.name,
        id: group.name,
        type: 'group',
    };
}

export function transformGroupsResponse(response: Group[]): GroupMention[] {
    return response.map(mapGroupToGroupMention);
}
